import { useMemo } from 'react';
import { commonProps } from './CustomComponents';
const { components: defaultComponents } = commonProps;
export const useMergeComponents = (components) => {
    return useMemo(() => ({
        ...defaultComponents,
        ...components,
    }), [components]);
};
